import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Constants from "../../constants";

const initialState = {
    clientList: [],
    clientId: '',
    showLoader: false
}

export const ProfileStatusFunction = createAsyncThunk(
    "profile/profileStatus", async (credentials) => {
        try {
            const response = await fetch(Constants.Api.commonUrl + 'ProfileStatusDetailJSON?Token=' + credentials.token + '&Client=' + credentials.client + '&Status=' + credentials.status + '&StatusPeriod=' + credentials.statusPeriod, {
                method: 'GET'
            })
            const data = await response.json()
            return data
        }
        catch (err) {
            return console.log('profile status function', err)
        }
    }
)

export const FeedbackStatusFunction = createAsyncThunk(
    'profile/feedbackStatus', async (credentials) => {
        try {
            const response = await fetch(Constants.Api.commonUrl + 'FeedbackStatusDetailJSON?Token=' + credentials.token + '&Status=' + credentials.status + '&StatusPeriod=' + credentials.statusPeriod + '&Client=' + credentials.client, {
                method: 'GET'
            })
            const data = await response.json()
            return data
        }
        catch (err) {
            return console.log('feedback status function', err)
        }
    }
)

export const SentRecievedFunction = createAsyncThunk(
    'profile/sentRecieved', async (credentials) => {
        try {
            const response = await fetch(Constants.Api.commonUrl + 'SentReceivedDetailJSON?Token=' + credentials.token + '&StatusPeriod=' + credentials.statusPeriod + '&Client=' + credentials.client, {
                method: 'GET'
            })
            const data = await response.json()
            return data
        }
        catch (err) {
            return console.log('sent and received status function', err)
        }
    }
)

export const TableJSONFunction = createAsyncThunk(
    "profile/clientJSON", async (credentials) => {
        try {
            const response = await fetch(Constants.Api.commonUrl + 'TablesJSON?Token=' + credentials.token + '&table=' + credentials.table, {
                method: 'GET'
            })
            const data = await response.json()
            return data
        }
        catch (err) {
            return console.log('client json err', err)
        }
    }
)

export const AddTableJSONFunction = createAsyncThunk(
    "profile/clientJSON", async (credentials) => {
       
        try {
            const response = await fetch(Constants.Api.commonUrl +'AddUpdateTableJSON?Token=' + credentials.token + '&Table=' + credentials.formData.TableName + '&Description=' + credentials.formData.Description + '&Type=' + credentials.formData.Type, {
                method: 'GET'
            })
            const data = await response.json()
            console.log("credentials",data)
            return data
        }
        catch (err) {
            return console.log('client json err', err)
        }
    }
)


export const columnsJSONFunction = createAsyncThunk(
    'system/columnsJSON',
    async (credentials) => {
        try {
            const response = await fetch(Constants.Api.commonUrl + 'ColumnsJSON?Token=' + credentials.token + '&table=' + credentials.tableID+ '&column=' + credentials.columnID, {
                method: 'GET'
            })
            const data = await response.json()
            return data
        }
        catch (err) {
            return console.log('client json err', err)
        }
    }
)

export const lookupsJSONFunction = createAsyncThunk(
    'system/columnsJSON', 
    async (credentials) => {
        try {
            const response = await fetch(Constants.Api.commonUrl + 'LookupListJSON?Token='+credentials.token+'&Language='+credentials.Language+'&Pronoun='+credentials.Pronoun+'&category='+credentials.category, {
                method: 'GET'
            })
            const data = await response.json()
            return data
        }
        catch (err) {
            return console.log('client json err', err)
        }
    }
)

export const languageListJSONFunction = createAsyncThunk(
    'system/languageJSON', 
    async (credentials) => {
        try {
            const response = await fetch(Constants.Api.commonUrl + 'LanguageListJSON?Token='+credentials.token+'&category='+credentials.category+'&Language='+credentials.language+'&gender='+credentials.gender+'&code='+credentials.code+'&pronoun='+credentials.pronoun, {
                method: 'GET'
            })
            const data = await response.json()
            return data
        }
        catch (err) {
            return console.log('client json err', err)
        }
    }
)

export const HelpScreenshotJSONFunction = createAsyncThunk(
    "profile/screenshotJSON", async (credentials) => {
        try {
            const response = await fetch(Constants.Api.commonUrl + 'ScreenHelpJSON?Language=' + credentials.language + '&Token=' + credentials.token + '&Screen=' + credentials.screen, {
                method: 'GET'
            })
            const data = await response.json()
            return data
        }
        catch (err) {
            return console.log('screenshotJSON error', err)
        }
    }
)

const profileStatusSlice = createSlice({
    name: 'profileStatus',
    initialState,
    reducers: {
        setClientId: (state, action) => {
            state.clientId = action.payload
        },
        reset: () => initialState
    },
    extraReducers: {
        [ProfileStatusFunction.pending]: (state, action) => {
            state.showLoader = true
        },
        [ProfileStatusFunction.fulfilled]: (state, action) => {
            state.showLoader = false
        },
        [ProfileStatusFunction.rejected]: (state, action) => {
            state.showLoader = false
        },

        [FeedbackStatusFunction.pending]: (state, action) => {
            state.showLoader = true
        },
        [FeedbackStatusFunction.fulfilled]: (state, action) => {
            state.showLoader = false
        },
        [FeedbackStatusFunction.rejected]: (state, action) => {
            state.showLoader = false
        },

        [SentRecievedFunction.pending]: (state, action) => {
            state.showLoader = true
        },
        [SentRecievedFunction.fulfilled]: (state, action) => {
            state.showLoader = false
        },
        [SentRecievedFunction.rejected]: (state, action) => {
            state.showLoader = false
        },

        [TableJSONFunction.pending]: (state, action) => {
            state.showLoader = true
        },
        [TableJSONFunction.fulfilled]: (state, action) => {
            if(Array.isArray(action['payload']['Result']['Table'])){
                state.clientList = action['payload']['Result']['Table'];
            }
            else if(!Array.isArray(action['payload']['Result']['Table'])){
                state.clientList = [action['payload']['Result']['Table']];
            }
            else{
                state.clientList = []
            }
            state.showLoader = false
        },
        [TableJSONFunction.rejected]: (state, action) => {
            state.showLoader = false
        },
     

        [HelpScreenshotJSONFunction.pending]: (state, action) => {

        },
        [HelpScreenshotJSONFunction.fulfilled]: (state, action) => {

        },
        [HelpScreenshotJSONFunction.rejected]: (state, action) => {

        },
        [AddTableJSONFunction.pending]: (state, action) => {
            
        },
        [AddTableJSONFunction.fulfilled]: (state, action) => {
           
        },
        [AddTableJSONFunction.rejected]: (state, action) => {
           
        },
     

        [columnsJSONFunction.pending]: (state, action) => {

        },
        [columnsJSONFunction.fulfilled]: (state, action) => {
            
            state.showLoader = false

        },
        [columnsJSONFunction.rejected]: (state, action) => {

        },
        [lookupsJSONFunction.pending]: (state, action) => {

        },
        [lookupsJSONFunction.fulfilled]: (state, action) => {
            if(Array.isArray(action['payload']['Result']['Table'])){
                state.clientList = action['payload']['Result']['Table'];
            }
            else if(!Array.isArray(action['payload']['Result']['Table'])){
                state.clientList = [action['payload']['Result']['Table']];
            }
            else{
                state.clientList = []
            }
            state.showLoader = false

        },
        [lookupsJSONFunction.rejected]: (state, action) => {

        },
        [languageListJSONFunction.pending]: (state, action) => {

        },
        [languageListJSONFunction.fulfilled]: (state, action) => {
            if(Array.isArray(action['payload']['Result']['Table'])){
                state.clientList = action['payload']['Result']['Table'];
            }
            else if(!Array.isArray(action['payload']['Result']['Table'])){
                state.clientList = [action['payload']['Result']['Table']];
            }
            else{
                state.clientList = []
            }
            state.showLoader = false

        },
        [languageListJSONFunction.rejected]: (state, action) => {

        }
    }
})

export const { setClientId, reset } = profileStatusSlice.actions
export default profileStatusSlice.reducer